var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/tutorials/viewmodels/index',["require", "exports", "common/viewmodelbase", "models/portal"], function (require, exports, Common, Portal) {
    "use strict";
    var TutorialsViewModel = (function (_super) {
        __extends(TutorialsViewModel, _super);
        function TutorialsViewModel() {
            _super.call(this);
            this.tutorials = [];
            this.title = "Tutorial";
            ko.track(this, ["tutorials"]);
        }
        TutorialsViewModel.prototype.onActivated = function (context) {
            this._symbol = {
                config: "",
                fragment: "tutorial",
                params: null,
                queryParams: null,
                queryString: null
            };
            this._currentNode = Portal.Context.shell.findNodeFor(this._symbol);
            this.getTutorialTiles();
        };
        TutorialsViewModel.prototype.getTutorialTiles = function () {
            var _this = this;
            if (this._currentNode.children != null) {
                var items = Enumerable.From(this._currentNode.children)
                    .Where(function (n) { return n.groupId === _this.title; });
                this.tutorials = items.ToArray();
            }
        };
        TutorialsViewModel.prototype.tutorialClick = function (node) {
            Portal.Context.shell.navigateTo(node);
        };
        return TutorialsViewModel;
    }(Common.ViewModelBase));
    var instance = new TutorialsViewModel();
    return instance;
});

